import { usePostPasswordChange } from '@repo/api/auth/usePostPasswordChange';
import { cn } from '@repo/lib/cn';
import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { PasswordInput } from '@/components/ui/input';
import { useIsDefaultLocation } from '@/hooks/default-location';
import { usePasswordChange } from '@/hooks/password-change';

export function PasswordChangeForm() {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = usePostPasswordChange();
  const { form, onSubmit } = usePasswordChange(mutateAsync);
  const isDefaultLocation: boolean = useIsDefaultLocation();

  return (
    <Form {...form}>
      <form className={'flex h-full w-full flex-col gap-6'} onSubmit={form.handleSubmit(onSubmit)} noValidate>
        <header className={'flex flex-col items-center gap-4 py-1 text-center'}>
          <div className="relative grid size-12 place-items-center">
            <img src={'/logo.png'} alt={'Better Call Paul logo'} className={'aspect-1 h-full w-full object-contain'} />
            <span aria-hidden className="bg-brand-accent/85 dark:bg-brand-accent/75 absolute -z-10 size-60 rounded-full blur-2xl" />
          </div>
          <div className={'flex flex-col items-center gap-1'}>
            <h1 className={'text-foreground text-2xl font-semibold'}>Zmień hasło</h1>
            <p className={'text-muted-foreground text-sm'}>Wprowadź nowe hasło i potwierdź je, aby kontynuować.</p>
          </div>
        </header>
        <fieldset className={'flex flex-col gap-2'}>
          <FormField
            name={'password'}
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Hasło</FormLabel>
                <FormControl>
                  <PasswordInput placeholder={'Hasło'} autoComplete={'current-password'} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            name={'confirmPassword'}
            control={form.control}
            render={({ field }) => (
              <FormItem>
                <FormLabel>Powtórz hasło</FormLabel>
                <FormControl>
                  <PasswordInput placeholder={'Powtórz Hasło'} autoComplete={'current-password'} {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </fieldset>
        <footer className={'mt-auto flex flex-row gap-3'}>
          <Button
            name="back button"
            type={'button'}
            variant={'outline'}
            onClick={() => {
              navigate(-1);
            }}
            className={cn(isDefaultLocation ? 'hidden' : 'w-full')}
          >
            Cofnij
          </Button>
          <Button disabled={isPending} type={'submit'} className={'w-full'}>
            {isPending ? 'Zapisywanie...' : 'Zapisz'}
          </Button>
        </footer>
      </form>
    </Form>
  );
}
